import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ngbd-timepicker-steps',
  templateUrl: './timepicker.component.html',
  styleUrls: ['./timepicker.component.css']
})
export class TimepickerComponent implements OnInit{
  @Output() messageEvent = new EventEmitter<any>();
  @Input() defaultTime: any;
  time: NgbTimeStruct;
  hourStep = 1;
  minuteStep = 1; 
  secondStep = 30;
  constructor() {
    // this.messageEvent.emit(this.time);
    // this.time = {hour: this.defaultTime.hour, minute: this.defaultTime.minute, second: 0};
  }
  ngOnInit(): void {
    // throw new Error('Method not implemented.');
  }

  onChange(time: any) {
    // this.time = {hour: this.defaultTime.hour, minute: this.defaultTime.minute, second: 0};
    //console.log(this.time,'onChange');
    
  }

  clickHour() {
    //console.log(this.time,'clickHour');
    this.messageEvent.emit(this.time);
  }

  keyHour() {
    let element: HTMLElement = document.getElementsByClassName('ngb-tp-spacer')[0] as HTMLElement;
    element.click();
    // document.getElementsByClassName('ngb-tp-spacer')[0].click();
    //console.log(this.time, 'keyHour');
    
  }


  onChangeEvent(event) {
    //console.log('call');
    this.messageEvent.emit(event);
}
}